@if (noActivatedChildren$ | async) {
    <div class="container-fluid pb-3">
        @if (view$ | async; as view) {
            @if (!view.loading) {
                <div class="p-1 text-end mb-3">
                    <button
                        type="button"
                        class="btn btn-outline-primary my-1"
                        (click)="downloadFile(view.value.buildingNo)">
                        {{ 'actions_export' | translate: 'online' : 'systems' }}
                    </button>
                    <button
                        type="button"
                        class="btn btn-outline-primary my-1 mx-2"
                        (click)="onSort({column: 'proBraLoc', direction: 'asc'})">
                        {{ 'utilities_STANDARDSORTORDER' | translate }}
                    </button>

                    <div
                        ngbDropdown
                        class="d-inline-block"
                        container="body"
                        placement="bottom-right">
                        <button
                            type="button"
                            class="btn btn-primary"
                            id="viewForm"
                            ngbDropdownToggle>
                            {{ 'utilities_VIEW' | translate }}
                        </button>
                        <div ngbDropdownMenu aria-labelledby="viewForm">
                            <form
                                class="px-4 py-3"
                                novalidate
                                [formGroup]="selectedColumnsForm"
                                (change)="updateSelectedColumns(selectedColumnsForm.getRawValue())">
                                <button
                                    type="button"
                                    class="btn btn-primary mb-3"
                                    style="margin-bottom: 5px"
                                    (click)="resetColumns()">
                                    {{ 'utilities_standard-view' | translate }}
                                </button>
                                <app-checkbox-group
                                    formControlName="mountingDate"
                                    [label]="
                                        'properties_mountingDate' | translate: 'online' : 'common'
                                    "></app-checkbox-group>
                                <app-checkbox-group
                                    formControlName="roomId"
                                    [label]="
                                        'properties_placement' | translate: 'online' : 'systems'
                                    "></app-checkbox-group>
                                <app-checkbox-group
                                    formControlName="scale"
                                    [label]="
                                        'properties_scale' | translate: 'online' : 'systems'
                                    "></app-checkbox-group>
                                <app-checkbox-group
                                    formControlName="unitFactor"
                                    [label]="
                                        'utilities_Technical_factor' | translate
                                    "></app-checkbox-group>
                                <app-checkbox-group
                                    formControlName="meterBuildLength"
                                    [label]="
                                        'utilities_meter_build_length' | translate
                                    "></app-checkbox-group>
                                <app-checkbox-group
                                    formControlName="meterConnectionType"
                                    [label]="
                                        'utilities_connection_type' | translate
                                    "></app-checkbox-group>
                                <app-checkbox-group
                                    formControlName="shutoffValve"
                                    [label]="
                                        'utilities_shutoff_valve' | translate
                                    "></app-checkbox-group>
                                <app-checkbox-group
                                    formControlName="supplyOrReturnFlow"
                                    [label]="
                                        'utilities_SUPPLYORRETURNFLOW' | translate
                                    "></app-checkbox-group>
                                <app-checkbox-group
                                    formControlName="radioTechnology"
                                    [label]="
                                        'utilities_radio_technology' | translate
                                    "></app-checkbox-group>
                                <app-checkbox-group
                                    formControlName="dinRail"
                                    [label]="
                                        'utilities_mounted_din' | translate
                                    "></app-checkbox-group>
                                <app-checkbox-group
                                    formControlName="maxCurrent"
                                    [label]="
                                        'utilities_max_current' | translate
                                    "></app-checkbox-group>
                                <app-checkbox-group
                                    formControlName="sensorPocket"
                                    [label]="
                                        'utilities_sensor_pocket' | translate
                                    "></app-checkbox-group>
                                <app-checkbox-group
                                    formControlName="meterSize"
                                    [label]="
                                        'utilities_size_flow' | translate
                                    "></app-checkbox-group>
                            </form>
                        </div>
                    </div>
                </div>
                <div class="table-responsive">
                    <table class="table table-striped table-sm">
                        <thead>
                            <tr>
                                @if (selectedColumnsForm.getRawValue().proBraLoc) {
                                    <th
                                        app-sortable-table-header
                                        [column]="'proBraLoc'"
                                        (sort)="onSort($event)"
                                        [label]="
                                            'properties_proBraLoc' | translate: 'online' : 'systems'
                                        "></th>
                                }
                                @if (selectedColumnsForm.getRawValue().address) {
                                    <th
                                        app-sortable-table-header
                                        [column]="'address'"
                                        (sort)="onSort($event)"
                                        [label]="
                                            'properties_address' | translate: 'online' : 'systems'
                                        "></th>
                                }
                                @if (selectedColumnsForm.getRawValue().meterSuperTypeNo) {
                                    <th
                                        app-sortable-table-header
                                        [column]="'meterSuperTypeNo'"
                                        (sort)="onSort($event)"
                                        [label]="
                                            'properties_type' | translate: 'online' : 'systems'
                                        "></th>
                                }
                                @if (selectedColumnsForm.getRawValue().alloUnitType) {
                                    <th
                                        app-sortable-table-header
                                        [column]="'alloUnitType'"
                                        (sort)="onSort($event)"
                                        [label]="
                                            'properties_usage' | translate: 'online' : 'systems'
                                        "></th>
                                }
                                @if (selectedColumnsForm.getRawValue().serialNo) {
                                    <th
                                        app-sortable-table-header
                                        [column]="'serialNo'"
                                        (sort)="onSort($event)"
                                        [label]="
                                            'properties_meterNo' | translate: 'online' : 'systems'
                                        "></th>
                                }
                                @if (selectedColumnsForm.getRawValue().meterModel) {
                                    <th
                                        app-sortable-table-header
                                        [column]="'meterModel'"
                                        (sort)="onSort($event)"
                                        [label]="
                                            'properties_meterModel'
                                                | translate: 'online' : 'systems'
                                        "></th>
                                }
                                @if (selectedColumnsForm.getRawValue().mountingDate) {
                                    <th
                                        app-sortable-table-header
                                        [column]="'mountingDate'"
                                        (sort)="onSort($event)"
                                        [label]="
                                            'properties_mountingDate'
                                                | translate: 'online' : 'common'
                                        "></th>
                                }
                                @if (selectedColumnsForm.getRawValue().roomId) {
                                    <th
                                        app-sortable-table-header
                                        [column]="'roomId'"
                                        (sort)="onSort($event)"
                                        [label]="
                                            'properties_placement' | translate: 'online' : 'systems'
                                        "></th>
                                }
                                @if (selectedColumnsForm.getRawValue().scale) {
                                    <th
                                        app-sortable-table-header
                                        [column]="'scale'"
                                        (sort)="onSort($event)"
                                        [label]="
                                            'properties_scale' | translate: 'online' : 'systems'
                                        "></th>
                                }
                                @if (selectedColumnsForm.getRawValue().unitFactor) {
                                    <th
                                        app-sortable-table-header
                                        [column]="'unitFactor'"
                                        (sort)="onSort($event)"
                                        [label]="'utilities_Technical_factor' | translate"></th>
                                }
                                @if (selectedColumnsForm.getRawValue().meterBuildLength) {
                                    <th
                                        app-sortable-table-header
                                        [column]="'meterBuildLength'"
                                        (sort)="onSort($event)"
                                        [label]="'utilities_meter_build_length' | translate"></th>
                                }
                                @if (selectedColumnsForm.getRawValue().meterConnectionType) {
                                    <th
                                        app-sortable-table-header
                                        [column]="'meterConnectionType'"
                                        (sort)="onSort($event)"
                                        [label]="'utilities_connection_type' | translate"></th>
                                }
                                @if (selectedColumnsForm.getRawValue().shutoffValve) {
                                    <th
                                        app-sortable-table-header
                                        [column]="'shutoffValve'"
                                        (sort)="onSort($event)"
                                        [label]="'utilities_shutoff_valve' | translate"></th>
                                }
                                @if (selectedColumnsForm.getRawValue().supplyOrReturnFlow) {
                                    <th
                                        app-sortable-table-header
                                        [column]="'supplyOrReturnFlow'"
                                        (sort)="onSort($event)"
                                        [label]="'utilities_SUPPLYORRETURNFLOW' | translate"></th>
                                }
                                @if (selectedColumnsForm.getRawValue().radioTechnology) {
                                    <th
                                        app-sortable-table-header
                                        [column]="'radioTechnology'"
                                        (sort)="onSort($event)"
                                        [label]="'utilities_radio_technology' | translate"></th>
                                }
                                @if (selectedColumnsForm.getRawValue().dinRail) {
                                    <th
                                        app-sortable-table-header
                                        [column]="'dinRail'"
                                        (sort)="onSort($event)"
                                        [label]="'utilities_mounted_din' | translate"></th>
                                }
                                @if (selectedColumnsForm.getRawValue().maxCurrent) {
                                    <th
                                        app-sortable-table-header
                                        [column]="'maxCurrent'"
                                        (sort)="onSort($event)"
                                        [label]="'utilities_max_current' | translate"></th>
                                }
                                @if (selectedColumnsForm.getRawValue().sensorPocket) {
                                    <th
                                        app-sortable-table-header
                                        [column]="'sensorPocket'"
                                        (sort)="onSort($event)"
                                        [label]="'utilities_sensor_pocket' | translate"></th>
                                }
                                @if (selectedColumnsForm.getRawValue().meterSize) {
                                    <th
                                        app-sortable-table-header
                                        [column]="'meterSize'"
                                        (sort)="onSort($event)"
                                        [label]="'utilities_size_flow' | translate"></th>
                                }
                                <th class="last-col bg-transparent"></th>
                            </tr>

                            <tr [formGroup]="formGroupFilter">
                                <th class="align-top">
                                    <app-input-text-group
                                        [formControl]="
                                            formGroupFilter.controls.proBraLoc
                                        "></app-input-text-group>
                                </th>
                                <th class="align-top">
                                    <app-input-text-group
                                        [formControl]="
                                            formGroupFilter.controls.address
                                        "></app-input-text-group>
                                </th>
                                <th class="align-top">
                                    <app-input-dropdown-checkboxes
                                        [formControl]="formGroupFilter.controls.meterSuperTypeNo" />
                                </th>
                                <th class="align-top">
                                    <app-input-dropdown-checkboxes
                                        [formControl]="formGroupFilter.controls.alloUnitType" />
                                </th>
                                <th class="align-top">
                                    <app-input-text-group
                                        [formControl]="
                                            formGroupFilter.controls.serialNo
                                        "></app-input-text-group>
                                </th>
                                <th class="align-top">
                                    <app-input-typeahead
                                        [formControl]="formGroupFilter.controls.meterModel"
                                        [filterValues]="true"
                                        [data]="view.value.meterModels"></app-input-typeahead>
                                </th>
                                @if (selectedColumnsForm.getRawValue().mountingDate) {
                                    <th class="align-top">
                                        <app-input-date-group
                                            [formControl]="formGroupFilter.controls.mountingDate">
                                        </app-input-date-group>
                                    </th>
                                }
                                @if (selectedColumnsForm.getRawValue().roomId) {
                                    <th class="align-top">
                                        <app-input-text-group
                                            [formControl]="
                                                formGroupFilter.controls.roomId
                                            "></app-input-text-group>
                                    </th>
                                }
                                @if (selectedColumnsForm.getRawValue().scale) {
                                    <th class="align-top">
                                        <app-input-text-group
                                            [formControl]="
                                                formGroupFilter.controls.scale
                                            "></app-input-text-group>
                                    </th>
                                }
                                @if (selectedColumnsForm.getRawValue().unitFactor) {
                                    <th class="align-top">
                                        <app-input-text-group
                                            [formControl]="
                                                formGroupFilter.controls.unitFactor
                                            "></app-input-text-group>
                                    </th>
                                }
                                @if (selectedColumnsForm.getRawValue().meterBuildLength) {
                                    <th class="align-top">
                                        <app-input-dropdown-checkboxes
                                            [formControl]="
                                                formGroupFilter.controls.meterBuildLength
                                            " />
                                    </th>
                                }
                                @if (selectedColumnsForm.getRawValue().meterConnectionType) {
                                    <th class="align-top">
                                        <app-input-dropdown-checkboxes
                                            [formControl]="
                                                formGroupFilter.controls.meterConnectionType
                                            " />
                                    </th>
                                }
                                @if (selectedColumnsForm.getRawValue().shutoffValve) {
                                    <th class="align-top">
                                        <app-input-dropdown-checkboxes
                                            [formControl]="formGroupFilter.controls.shutoffValve" />
                                    </th>
                                }

                                @if (selectedColumnsForm.getRawValue().supplyOrReturnFlow) {
                                    <th class="align-top">
                                        <app-input-dropdown-checkboxes
                                            [formControl]="
                                                formGroupFilter.controls.supplyOrReturnFlow
                                            " />
                                    </th>
                                }
                                @if (selectedColumnsForm.getRawValue().radioTechnology) {
                                    <th class="align-top">
                                        <app-input-dropdown-checkboxes
                                            [formControl]="
                                                formGroupFilter.controls.radioTechnology
                                            " />
                                    </th>
                                }
                                @if (selectedColumnsForm.getRawValue().dinRail) {
                                    <th class="align-top">
                                        <app-input-dropdown-checkboxes
                                            [formControl]="formGroupFilter.controls.dinRail" />
                                    </th>
                                }

                                @if (selectedColumnsForm.getRawValue().maxCurrent) {
                                    <th class="align-top">
                                        <app-input-dropdown-checkboxes
                                            [formControl]="formGroupFilter.controls.maxCurrent" />
                                    </th>
                                }
                                @if (selectedColumnsForm.getRawValue().sensorPocket) {
                                    <th class="align-top">
                                        <app-input-dropdown-checkboxes
                                            [formControl]="formGroupFilter.controls.sensorPocket" />
                                    </th>
                                }
                                @if (selectedColumnsForm.getRawValue().meterSize) {
                                    <th class="align-top">
                                        <app-input-dropdown-checkboxes
                                            [formControl]="formGroupFilter.controls.meterSize" />
                                    </th>
                                }
                                <th class="last-col bg-transparent"></th>
                            </tr>
                        </thead>
                        <tbody class="text-nowrap">
                            @for (
                                location of view.value.meters
                                    | slice
                                        : (meterService.page() - 1) * meterService.pageSize()
                                        : meterService.page() * meterService.pageSize();
                                track $index
                            ) {
                                <tr>
                                    @if (selectedColumnsForm.getRawValue().proBraLoc) {
                                        <td>
                                            {{ location?.proBraLoc }}
                                        </td>
                                    }
                                    @if (selectedColumnsForm.getRawValue().address) {
                                        <td>
                                            {{ location.address }}
                                        </td>
                                    }
                                    @if (selectedColumnsForm.getRawValue().meterSuperTypeNo) {
                                        <td>
                                            {{
                                                'mappers_meterType.' + location.meterSuperTypeNo
                                                    | translate: 'online' : 'common'
                                            }}
                                        </td>
                                    }
                                    @if (selectedColumnsForm.getRawValue().alloUnitType) {
                                        <td>
                                            {{
                                                'mappers_allocationUnitMap.' + location.alloUnitType
                                                    | translate: 'online' : 'common'
                                            }}
                                        </td>
                                    }
                                    @if (selectedColumnsForm.getRawValue().serialNo) {
                                        <td>
                                            {{ location.serialNo }}
                                        </td>
                                    }
                                    @if (selectedColumnsForm.getRawValue().meterModel) {
                                        <td>
                                            {{ location.meterModel }}
                                        </td>
                                    }
                                    @if (selectedColumnsForm.getRawValue().mountingDate) {
                                        <td>
                                            {{ location.mountingDate | appdate }}
                                        </td>
                                    }
                                    @if (selectedColumnsForm.getRawValue().roomId) {
                                        <td>
                                            {{ location.roomId }}
                                        </td>
                                    }
                                    @if (selectedColumnsForm.getRawValue().scale) {
                                        <td>
                                            {{ location.scale | appnumber }}
                                        </td>
                                    }
                                    @if (selectedColumnsForm.getRawValue().unitFactor) {
                                        <td>
                                            {{ location.unitFactor | appnumber }}
                                        </td>
                                    }
                                    @if (selectedColumnsForm.getRawValue().meterBuildLength) {
                                        <td>
                                            {{ location.meterBuildLength | appnumber }}
                                        </td>
                                    }
                                    @if (selectedColumnsForm.getRawValue().meterConnectionType) {
                                        <td>
                                            {{ location.meterConnectionType }}
                                        </td>
                                    }
                                    <!-- Connection type -->
                                    @if (selectedColumnsForm.getRawValue().shutoffValve) {
                                        <td>
                                            @switch (location.shutoffValve) {
                                                @case ('B') {
                                                    {{ 'utilities_.BEFORE' | translate }}
                                                }
                                                @case ('A') {
                                                    {{ 'utilities_.AFTER' | translate }}
                                                }
                                                @case ('M') {
                                                    {{ 'utilities_.BOTH' | translate }}
                                                }
                                                @case ('N') {
                                                    {{ 'utilities_.NONE' | translate }}
                                                }
                                            }
                                        </td>
                                    }
                                    @if (selectedColumnsForm.getRawValue().supplyOrReturnFlow) {
                                        <td>
                                            @switch (location.supplyOrReturnFlow) {
                                                @case ('C') {
                                                    {{ 'utilities_.COLD' | translate }}
                                                }
                                                @case ('W') {
                                                    {{ 'utilities_.WARM' | translate }}
                                                }
                                            }
                                        </td>
                                    }

                                    @if (selectedColumnsForm.getRawValue().radioTechnology) {
                                        <td>
                                            @if (location.radioTechnology) {
                                                {{
                                                    'radiotechnology_' + location.radioTechnology
                                                        | translate
                                                }}
                                            }
                                        </td>
                                    }
                                    @if (selectedColumnsForm.getRawValue().dinRail) {
                                        <td>
                                            @if (location.dinRail != null) {
                                                <app-true-false
                                                    [value]="location.dinRail"></app-true-false>
                                            }
                                        </td>
                                    }
                                    @if (selectedColumnsForm.getRawValue().maxCurrent) {
                                        <td>
                                            {{ location.maxCurrent | appnumber }}
                                        </td>
                                    }
                                    @if (selectedColumnsForm.getRawValue().sensorPocket) {
                                        <td>
                                            <app-true-false
                                                [value]="
                                                    location.sensorPocket ?? false
                                                "></app-true-false>
                                        </td>
                                    }
                                    @if (selectedColumnsForm.getRawValue().meterSize) {
                                        <td>
                                            {{ location.meterSize }}
                                        </td>
                                    }
                                    <td class="last-col text-end">
                                        <button
                                            class="btn btn-link btn-sm px-0 py-0"
                                            (click)="saveFilter()"
                                            [routerLink]="[location.meterId]"
                                            style="cursor: pointer">
                                            {{ 'common_SHOW' | translate }}
                                        </button>
                                    </td>
                                </tr>
                            }
                            @if (view.value.meters.length === 0) {
                                <tr>
                                    <td colspan="21" class="text-center">
                                        {{ 'table_noResults' | translate: 'online' : 'common' }}
                                    </td>
                                </tr>
                            }
                        </tbody>
                    </table>
                </div>
                <div class="text-center">
                    <app-pagination
                        [collectionSize]="view.value.collectionSize"
                        [page]="meterService.page()"
                        (pageChange)="setPage($event)"
                        (pageSizeChange)="setPageSize($event)"
                        [pageSize]="meterService.pageSize()">
                    </app-pagination>
                </div>
            } @else {
                <app-load />
            }
        } @else {
            <app-load />
        }
    </div>
}

<router-outlet />
